import { useEffect } from 'react'
import { Container } from 'typescript-ioc/es5'
import { observe } from 'mobx'
import { AppService } from '@halo/services/app.service'
import { DomainDto } from '@halo/dtos/domain.dto'
import { AppState } from '@halo/stores/app.state'

export const useActiveDomainChangeEffect = (onChange: (domain: DomainDto, appSvc: AppService) => any) => {
    const app: AppState = Container.get(AppState)

    useEffect(() => {
        return observe(app, 'currentDomainJsonData', (change) => {
            const oldValue = JSON.parse(change.oldValue ?? '{}')
            const newValue = JSON.parse(change.newValue ?? '{}')

            if (oldValue.id !== newValue.id) {
                const svc: AppService = Container.get(AppService)
                onChange(app.currentDomain!, svc)
            }
        })
    })
}
